import { useMemo } from 'react';
import { useUserPermissions } from 'entities/user';
import { useIsAutorizedUser } from 'store/features/auth';

export const usePaymentsVisibility = () => {
   const permissions = useUserPermissions();
   const isAutorizedUser = useIsAutorizedUser();

  return useMemo(() => ({
    buildingRouteFilter: !!permissions.buildingRoutePaymentMethodsSelect && isAutorizedUser,
    stationsFilter: !!permissions.servicePointFilterPaymentMethodsSelect && isAutorizedUser
  }), [permissions, isAutorizedUser]);
};
